package one.healthium.uscreen.serialization

import kotlinx.serialization.KSerializer
import kotlinx.serialization.builtins.serializer
import kotlinx.serialization.descriptors.SerialDescriptor
import kotlinx.serialization.descriptors.buildClassSerialDescriptor
import kotlinx.serialization.descriptors.element
import kotlinx.serialization.encoding.CompositeDecoder
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder
import kotlinx.serialization.encoding.decodeStructure
import kotlinx.serialization.json.JsonDecoder
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import one.healthium.uscreen.domain.models.GenderText

object GenderTextSerializer : KSerializer<GenderText> {
    override val descriptor: SerialDescriptor =
        buildClassSerialDescriptor("one.healthium.uscreen.domain.models.GenderText") {}

    override fun deserialize(decoder: Decoder): GenderText {
        val input = decoder as JsonDecoder
        return when (val element = input.decodeJsonElement()) {
            is JsonPrimitive -> GenderText(input.json.decodeFromJsonElement(String.serializer(), element))
            is JsonObject -> input.json.decodeFromJsonElement(GenderTextObjectSerializer, element)
            else -> error("Unexpected JSON element for GenderText")
        }
    }

    override fun serialize(encoder: Encoder, value: GenderText) {
        if (value.men == value.women) {
            encoder.encodeString(value.men)
        } else {
            GenderTextObjectSerializer.serialize(encoder, value)
        }
    }
}

private object GenderTextObjectSerializer : KSerializer<GenderText> {
    override val descriptor: SerialDescriptor =
        buildClassSerialDescriptor("GenderTextObject") {
            element<String>("men")
            element<String>("women")
        }

    override fun deserialize(decoder: Decoder): GenderText {
        return decoder.decodeStructure(descriptor) {
            var men: String? = null
            var women: String? = null
            while (true) {
                when (val index = decodeElementIndex(descriptor)) {
                    0 -> men = decodeStringElement(descriptor, 0)
                    1 -> women = decodeStringElement(descriptor, 1)
                    CompositeDecoder.DECODE_DONE -> break
                    else -> error("Unexpected index: $index")
                }
            }
            requireNotNull(men) { "GenderText requires 'men' field" }
            requireNotNull(women) { "GenderText requires 'women' field" }
            GenderText(men = men, women = women)
        }
    }

    override fun serialize(encoder: Encoder, value: GenderText) {
        encoder.beginStructure(descriptor).apply {
            encodeStringElement(descriptor, 0, value.men)
            encodeStringElement(descriptor, 1, value.women)
            endStructure(descriptor)
        }
    }
}
